import EventBus, { AppEvents } from '@/core/EventBus.js';
import InitiativeService from '@/services/InitiativeService.js';
import { portfolioStore } from './portfolioStore.js';

function refresh() {
  try {
    const list = InitiativeService.getInitiatives();
    portfolioStore.setInitiatives(list);
  } catch (_) {}
}

// Subscribe once when imported
try {
  EventBus.on(AppEvents.INITIATIVE_ADDED, refresh);
  EventBus.on(AppEvents.INITIATIVE_UPDATED, refresh);
  EventBus.on(AppEvents.INITIATIVE_DELETED, refresh);
  EventBus.on(AppEvents.INITIATIVES_CLEARED, refresh);
} catch (_) {}

export default {};
